<div class="layout-breadcrumb-container flex justify-content-between align-items-center shadow-1">
    <p-breadcrumb [model]="(applicationServiceExt.breadcrumbItems$ | async)" [home]="menuItemHome" styleClass="layout-breadcrumb pl-4 py-2" (onItemClick)="onItemClickAsync($event)">
    </p-breadcrumb>
    <ng-content></ng-content>
</div>
